import { stringify } from 'qs';
import request from '@/utils/request';
import { async } from 'q';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function save(payload) {
  return request(`/iwms-basic/basic/workingScheme`, {
    method: 'POST',
    body: payload,
  });
}
export async function getByUuid(uuid) {
  return request(`/iwms-basic/basic/workingScheme/${uuid}`);
}

export async function getSchemeForDc(uuid){
  const companyUuid=loginCompany().uuid;
  const dcUuid=loginOrg().uuid;
  return request(`/iwms-wms/wms/processSchemeLimit/getForDc?companyUuid=${companyUuid}&dcUuid=${dcUuid}&schemeUuid=${uuid}`)
}

export async function getByCodeForDc(payload) {
  const companyUuid=loginCompany().uuid;
  const dcUuid=loginOrg().uuid;
  return request(`/iwms-wms/wms/processSchemeLimit/getByCodeForDc?companyUuid=${companyUuid}&dcUuid=${dcUuid}&schemeCode=${payload.schemeCode}`)
}

export async function getByCompanyUuidAndCode(code) {
  const companyUuid = loginCompany().uuid;
  return request(`/iwms-basic/basic/workingScheme/${companyUuid}/get?code=${code}`);
}

export async function modify(payload) {
  return request(`/iwms-basic/basic/workingScheme/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveOrModifyForDc(payload){
  return request(`/iwms-wms/wms/processSchemeLimit/saveOrModify`,{
    method: 'POST',
    body: payload,
  })
}

export async function query(payload) {
  return request(`/iwms-basic/basic/workingScheme/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function online(payload) {
  return request(`/iwms-basic/basic/workingScheme/${payload.uuid}/online?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function offline(payload) {
  return request(`/iwms-basic/basic/workingScheme/${payload.uuid}/offline?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function remove(payload) {
  return request(`/iwms-basic/basic/workingScheme/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  });
}

// 批量保存配送中心
export async function dcbatchsave(params) {
  return request(`/iwms-basic/basic/workingScheme/${params.uuid}/dcbatchsave?companyUuid=${loginCompany().uuid}`, {
    method: 'POST',
    body: params.dcCodes
  })
}

// 保存配送中心
export async function saveOneDc(payload) {
  return request(`/iwms-basic/basic/workingScheme/dc`, {
    method: 'POST',
    body: payload
  })
}

//删除配送中心
export async function removeDC(params) {
  return request(`/iwms-basic/basic/workingScheme/dc/${params}/remove`, {
    method: 'DELETE'
  })
}

// 导入
export async function batchImport(payload) {
  return request(`/iwms-basic/basic/workingScheme/batchimport?companyUuid=${loginCompany().uuid}&fileKey=${payload.fileKey}`, {
    method: 'POST'
  });
}



